import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="bg-white border-b border-[#E8E2D6]" aria-label="Breadcrumb">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <ol className="flex items-center gap-2 text-sm">
          <li>
            <Link
              to="/"
              className="text-[#1A2332]/60 hover:text-[#E8B84B] transition-colors flex items-center gap-1"
            >
              <i className="ri-home-line"></i>
              Home
            </Link>
          </li>
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-2">
              <i className="ri-arrow-right-s-line text-[#1A2332]/40"></i>
              {item.path ? (
                <Link
                  to={item.path}
                  className="text-[#1A2332]/60 hover:text-[#E8B84B] transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-[#1A2332] font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}

export { Breadcrumb };